/*
  "Carry on where you left off" on Rep Home: the sheet already part way
  through, which is almost always the thing a rep wants on opening the app. The one they touched most recently, so picking the
  app up carries on rather than starting a hunt.

  **"Touched" is the last number typed on it** (the audit after the rebrand,
  issue 29, 18 September 2026). It sorted on the sheet's `updated_at`, which
  this screen never asked for, so every sheet tied and the first in-progress
  one in the database's order won. A sheet's own `updated_at` also does not
  move when a number is typed, only when its status does, so it is the
  fallback rather than the answer.
*/
export function pickCarryOn(counts = [], lineItems = []) {
  const open = counts.filter(c => c.status === 'in_progress');
  if (!open.length) return null;
  const touched = {};
  for (const i of lineItems) {
    const t = i.last_updated_at ? new Date(i.last_updated_at).getTime() : 0;
    if (t > (touched[i.inventory_count_id] || 0)) touched[i.inventory_count_id] = t;
  }
  const when = c => touched[c.id] || (c.updated_at ? new Date(c.updated_at).getTime() : 0);
  const pick = open.slice().sort((a, b) => when(b) - when(a))[0];
  const mine = lineItems.filter(i => i.inventory_count_id === pick.id);
  const full = mine.filter(i => i.quantity !== null && i.quantity !== undefined).length;
  // The clean name and the territory, as the cards print them. Only a
  // location the database has never split falls back to cutting the raw name
  // at its first dash, which is wrong for a name like "HOUSTON NORTH-WEST"
  // with no territory on the front.
  const w = pick.warehouse || {};
  const whole = w.name || 'A location';
  const cut = whole.indexOf('-');
  return {
    id: pick.id,
    terr: w.display_name ? (w.region_prefix || '') : (cut > 0 ? whole.slice(0, cut) : ''),
    name: w.display_name || (cut > 0 ? whole.slice(cut + 1) : whole),
    done: full, total: mine.length || full,
  };
}
